var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #6d6d6d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.2,233.1l19.9,15.5c2.6,2.1,4.5,4.7,5.6,7.6,48.5-43.7,71-86.1,81.3-114.7,2.9-7.8,1.3-15.4-4.2-19.7s-13.2-4-20.1.7c-25.1,17.1-60.7,49.2-91.3,106.8,3.1.4,6.1,1.6,8.8,3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,255.8l-19.4-15.1c-4.2-3.3-10.2-2.5-13.4,1.7l-5,6.4c1.5.5,2.9,1.3,4.2,2.2l27.1,21.1c1.3,1,2.4,2.2,3.2,3.5l5-6.4c3.3-4.2,2.5-10.2-1.7-13.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.5,283.3c0-1.5-.6-2.8-1.8-3.8l-27.1-21.1c-1-.8-2.2-1.1-3.4-1-1,.1-23.9,2.6-34.8,20.4-7.4,12.2-7.2,28.1.4,47.4.4.8.8,1.5,1.5,2s1.7.9,2.7,1c1.8.1,3.6-.8,4.4-2.5,0-.1,5.7-10.1,18.1-14.1,3.4-1,7.4-1.3,11.6-1.5,11.8-.7,27.9-1.5,28.4-26.9h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.870083c540ae4da575793b2dba1bf507.svg";
export { ForwardRef as ReactComponent };